import {KoAPI} from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;
export const ProfileAPI = {

  getInbox(){
    return KoAPI.get(`/api/${version}/home/inbox/approvals`);
  },
  getIntervals(workspaceId, query){
    return KoAPI.get(`/api/${version}/home/timesheet/intervals`, {query: { ...query }, header: {
      "workspace": workspaceId
    } });
  },
  getRejectedCount(query){
    return KoAPI.get(`/api/${version}/home/timesheet/dashboard/log/reject`, { query: { ...query } });
  },
  getProfile(id){
    return KoAPI.get(`/api/${version}/org/profile/${id}`);
  },
  updateFieldProfile(data, id){
    return KoAPI.patch(`/api/${version}/org/profile/field/${id}`, { data : data });
  },
  updateProfile(data, id){
    return KoAPI.update(`/api/${version}/org/profile/${id}`, { data : data });
  },
  getPreference(){
    return KoAPI.get(`/api/${version}/org/profile/user/preference`);
  },
  getTimesheet(){
    return KoAPI.get(`/api/${version}/home/timesheet`);
  },
  getAllWorkLogsTime(query, workspaceId){
    return KoAPI.get(`/api/${version}/home/timesheet/week/worklog`, { query: { ...query }, header: {
      "workspace": workspaceId
    } });
  },
  getTimesheetById(id){
    return KoAPI.get(`/api/${version}/home/timesheet/${id}`);
  },
  createOrUpdateTimesheet(data, id, workspaceId) {
    if(id){
      return KoAPI.update(`/api/${version}/home/timesheet/worklog/${id}`, { data: { ...data }, header: {
        "workspace": workspaceId
      }});
    }else{
      return KoAPI.post(`/api/${version}/home/timesheet`, { data: { ...data }, header: {
        "workspace": workspaceId
      }});
    }
  },
  deleteTimesheetById(id, workspaceId){
    return KoAPI.delete(`/api/${version}/home/timesheet/worklog/${id}`, { header: {
      "workspace": workspaceId
    }});
  },
  getBillableNonBillableTime(query){
    return KoAPI.get(`/api/${version}/home/timesheet/dashboard/billable`, { query: { ...query } });
  },
  getTaskAssignedCount(query){
    return KoAPI.get(`/api/${version}/home/timesheet/dashboard/task`, { query: { ...query } });
  },
  getCurrentWeekTotalWorkTime(query){
    return KoAPI.get(`/api/${version}/home/timesheet/dashboard/time`, { query: { ...query } });
  },
  getTotalHours(query){
    return KoAPI.get(`/api/${version}/home/timesheet/dashboard/hours`, { query: { ...query } });
  },

  getLeaveTypes(){
    return KoAPI.get(`/api/${version}/admin/leave/user/days`);
  },

  getAllRejectedWorkLogsTime(query, workspaceId){
    return KoAPI.get(`/api/${version}/home/timesheet/week/worklog/rejected`, { query: { ...query }, header: {
      "workspace": workspaceId
    } });
  },
  
  getClients(){
    return KoAPI.get(`/api/${version}/admin/customer`);
  },
      
  getRecentTicket(query) {
    return KoAPI.get(`/api/${version}/taskplanner/ticket/recent`, { query: { ...query } });
  },

  getWorkspaceById(id){
    return KoAPI.get(`/api/${version}/workspace/${id}`);
  },
  sendApprovalRequest(query, data, workspace){
    return KoAPI.update(`/api/${version}/home/ticket/worklog/approval`, { query: { ...query }, data, header: { "workspace": workspace } });
  },
  cancelTimesheet(data, query, workspace){
    return KoAPI.update(`/api/${version}/home/ticket/worklog/approvel/cancel`, { data, query: { ...query }, header: { "workspace": workspace } });
  },

  getWorkspaceData(q) {
    return KoAPI.get(`/api/v1/home/timesheet/list/workspace`, { query: { ...q } });
  },
  getAllWorklogs() {
    return KoAPI.get(`/api/v1/home/timesheet/month/worklog`);
  },
  applyLeave(data, id) {
    if(id){
      return KoAPI.update(`/api/${version}/admin/leave/request/${id}`, { data });
    }else{
      return KoAPI.post(`/api/${version}/admin/leave/request`, { data });
    }
   
  },
  getHolidays(query) {
    return KoAPI.get(`/api/${version}/admin/leave/org/holidays`, { query: { ...query }});
  },
  getLeaveRequests() {
    return KoAPI.get(`/api/${version}/admin/leave/requests`);
  },
  sendLeaveRequest(data) {
    return KoAPI.update(`/api/${version}/admin/leave/request/approval`, { data });
  },
  deleteLeaveRequest(id) {
    return KoAPI.delete(`/api/${version}/admin/leave/request/${id}`);
  },
  getWorklogsCount(query) {
    return KoAPI.get(`/api/${version}/home/timesheet/count/log`, { query: { ...query } });
  },
  getApprovalCount(query) {
    return KoAPI.get(`/api/${version}/home/inbox/count/waiting/approver`, { query: { ...query } });
  },
  getLeaveCount() {
    return KoAPI.get(`/api/${version}/admin/leave/requests/count/waiting`);
  }
};